import { useMemo } from 'react'
import { LANGUAGES_DASHBOARD_TYPES } from '@/shared/constants/languages'
import { useDashboardDisplayLanguageStore } from '@/shared/store/display-language-store'

export function useDashboardDisplayLanguage() {
  const activeLanguage = useDashboardDisplayLanguageStore((state) => state.activeLanguage)
  const setActiveLanguage = useDashboardDisplayLanguageStore((state) => state.setActiveLanguage)

  const fallbackLanguage = useMemo(
    () =>
      activeLanguage === LANGUAGES_DASHBOARD_TYPES.VI
        ? LANGUAGES_DASHBOARD_TYPES.ENG
        : LANGUAGES_DASHBOARD_TYPES.VI,
    [activeLanguage],
  )

  return {
    activeLanguage,
    fallbackLanguage,
    setActiveLanguage,
  }
}
